import PersonAvatar from "./PersonAvatar";

const PeopleList = ({ people }) => {
  return (
    <div className="d-flex flex-wrap">
      {people.map((person, index) => {
        return (
          <PersonAvatar
            avatar={person.avatar_url}
            name={person.fullName}
            key={index}
          />
        );
      })}
    </div>
  );
};

export default PeopleList;
